import { Spin, Table } from "antd";
import { IUnlockApprovalDetail } from "../hooks/useGetUnlockApprovalsByReference";

interface IApprovalHistoryTabProps {
  data: IUnlockApprovalDetail[] | undefined;
  isLoading: boolean;
}

const columns = [
  {
    title: "Initiated By",
    dataIndex: "initiatedByUserName",
    key: "initiatedByUserName",
  },
  {
    title: "Initiator Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Approved By",
    dataIndex: "approvedByUserName",
    key: "approvedByUserName",
  },
  {
    title: "Status",
    dataIndex: "statusText",
    key: "statusText",
  },
  {
    title: "Additional Unlock Description",
    dataIndex: "additionalUnlockDescription",
    key: "additionalUnlockDescription",
  },
  {
    title: "Additional Lock Description",
    dataIndex: "additionalLockDescription",
    key: "additionalLockDescription",
  },
  {
    title: "Unlock Reason",
    dataIndex: "unlockReason",
    key: "unlockReason",
  },
  {
    title: "Lock Reason",
    dataIndex: "lockReason",
    key: "lockReason",
  },
  {
    title: "Comment",
    dataIndex: "approvalComment",
    key: "approvalComment",
  },
  {
    title: "Date Initiated",
    dataIndex: "dateInitiated",
    key: "dateInitiated",
    render: (value: string) => (value ? new Date(value).toLocaleString() : "-"),
  },
];

export default function ApprovalHistoryTab({
  data,
  isLoading,
}: IApprovalHistoryTabProps) {
  return (
    <Spin spinning={isLoading}>
      <Table
        dataSource={data ?? []}
        rowKey="transactionReference"
        pagination={false}
        scroll={{ x: 1500 }}
        columns={columns}
      />
    </Spin>
  );
}
